import { FC, SVGProps } from 'react'

import AddIcon from 'static/icons/add.svg?react'
import ArrowForwardIcon from 'static/icons/arrow-forward.svg?react'
import BellIcon from 'static/icons/bell.svg?react'
import CallIcon from 'static/icons/call.svg?react'
import ConstructIcon from 'static/icons/construct.svg?react'
import ConstructTabIcon from 'static/icons/construct-tab.svg?react'
import DocumentIcon from 'static/icons/document.svg?react'
import DocumentTabIcon from 'static/icons/document-tab.svg?react'
import HomeIcon from 'static/icons/home.svg?react'
import MailIcon from 'static/icons/mail.svg?react'
import MegaphoneIcon from 'static/icons/megaphone.svg?react'
import MegaphoneTabIcon from 'static/icons/megaphone-tab.svg?react'
import PeopleIcon from 'static/icons/people.svg?react'
import PersonIcon from 'static/icons/person.svg?react'
import PersonTabIcon from 'static/icons/person-tab.svg?react'
import PricetagIcon from 'static/icons/pricetag.svg?react'
import ReceiptIcon from 'static/icons/receipt.svg?react'
import ShieldIcon from 'static/icons/shield.svg?react'
import WarningIcon from 'static/icons/warning.svg?react'

const icons = {
  add: AddIcon,
  arrowForward: ArrowForwardIcon,
  bell: BellIcon,
  call: CallIcon,
  construct: ConstructIcon,
  constructTab: ConstructTabIcon,
  document: DocumentIcon,
  documentTab: DocumentTabIcon,
  home: HomeIcon,
  mail: MailIcon,
  megaphone: MegaphoneIcon,
  megaphoneTab: MegaphoneTabIcon,
  people: PeopleIcon,
  person: PersonIcon,
  personTab: PersonTabIcon,
  pricetag: PricetagIcon,
  receipt: ReceiptIcon,
  shield: ShieldIcon,
  warning: WarningIcon
} as const

export type R4RIconName = keyof typeof icons

interface R4RIconProps extends SVGProps<SVGSVGElement> {
  name: R4RIconName
  size?: number
}

// Icons exported from the "Panel Klienta 3.0" Figma design.
// They inherit color from CSS `color` (currentColor).
const R4RIcon: FC<R4RIconProps> = ({ name, size = 24, ...props }) => {
  const Icon = icons[name]
  return <Icon width={size} height={size} {...props} />
}

export default R4RIcon
